import PageHero from "../components/PageHero.jsx";
import CTA from "../components/CTA.jsx";
import { applicationBlocks } from "../data/content.js";

export default function Applications() {
  return (
    <>
      <PageHero
        eyebrow="Applications / Industries"
        title="Designed for modern food ecosystems."
        text="Freeze-dried ingredients can support modern tea, wellness, nutraceutical, functional food, HoReCa and healthy snack applications."
        image="/images/premium-fruit-bowl.jpg"
      />

      <section className="content-band">
        <div className="section-inner application-grid">
          {applicationBlocks.map((item) => (
            <article key={item.title} className="application-block">
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </article>
          ))}
        </div>
      </section>

      <CTA />
    </>
  );
}
